import styles from "./TutoBox.module.scss";
import React, { useEffect, useRef, useState } from "react";
import { gsap } from "gsap";
import emitter from "../../emitter";
import CloseIcon from "@mui/icons-material/Close";
import NavigateBeforeRoundedIcon from '@mui/icons-material/NavigateBeforeRounded';
import NavigateNextRoundedIcon from '@mui/icons-material/NavigateNextRounded';
export default function TutoBox() {
  const [slide, setSlide] = useState(0);
  const container = useRef();
  const wrapper = useRef();

  const content = [
    "Lancez une des 5 quêtes proposées dans le hall pour démarrer un parcours sur la thématique de votre choix.",
    "Laissez-vous guider dans les pièces de la maison et cliquez sur les objets en surbrillance pour découvrir des contenus inspirants.",
    "Collectez les conseils et accompagnements dans votre panier pour y revenir à tout moment.",
    "Consultez la jauge pour découvrir votre avancée au sein d'une quête.",
  ];

  const title = [
    ["Choisissez", "une quête"],
    ["Explorez", "les pièces"],
    ["Collectez", "les conseils"],
    ["Consultez", "la jauge"]
  ]

  // Fonction pour gérer le clic sur les flèches du tutoriel
  const handleTutorialArrowClick = (direction) => {
    // Assurez-vous que window.dataLayer existe
    window.dataLayer = window.dataLayer || [];

    // Identifier le tutoriel actuel en fonction du slide
    let tutorialStep = `tutoriel${slide + 1}`; // +1 car les slides commencent à 0
    // Pousser l'événement dans le Data Layer
    window.dataLayer.push({
      event: 'click.action',
      click: tutorialStep,
    });
  };

  // Fonction pour gérer le clic sur la croix (fin du tutoriel)
  const handleTutorialCloseClick = () => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'click.action',
      click: 'tutoriel_fin'
    });

    // Fermer le tutoriel
    animOut();
  };



  useEffect(() => {
    // Animation pour aller au slide actuel
    gsap.to(container.current, {
      x: 0 * slide,
      duration: 0.5,
    });
  }, [slide]);

  const goToNextSlide = () => {
    handleTutorialArrowClick('next');

    setSlide((prevSlide) => {
      // Vérifier si la slide actuelle est la dernière
      if (prevSlide === content.length - 1) {
        // Si c'est la dernière slide, fermer la modale
        animOut();
        // Optionnellement, remettre la slide à la première (ou selon votre logique d'interface)
        return 0;
      } else {
        // Passer à la slide suivante
        return (prevSlide + 1) % content.length;
      }
    });
  };

  const goToPrevSlide = () => {
    handleTutorialArrowClick('prev');

    setSlide((prevSlide) => (prevSlide - 1 + content.length) % content.length);
  };

  const onChangeHandler = (e) => {
    const selectedSlide = parseInt(e.target.value, 10); // Convertir la valeur en nombre
    setSlide(selectedSlide); // Mettre à jour la diapositive en fonction du radio input cliqué

  };

  const animIn = () => {
    gsap.to(wrapper.current, {
      autoAlpha: 1,
      duration: 0.5,
      pointerEvents: "auto",
      ease: "power1.out",
    });
  };

  const animOut = () => {
    gsap.to(wrapper.current, {
      autoAlpha: 0,
      duration: 0.5,
      pointerEvents: "none",
      ease: "power1.out",
    });
  };

  useEffect(() => {
    emitter.on("tuto:open", animIn);
  });

  return (
    <>
      <div className={styles.tuto} ref={wrapper}>
        <div className={styles.tutobox} >


          <button
            className={styles.popupClose}
            aria-label={"Bouton fermer la modale du tutoriel"}
            onClick={handleTutorialCloseClick} // Utiliser ici la fonction de fermeture
          >
            <CloseIcon />
          </button>
          <div className={styles.container}>
            <img src={`/images/tuto${slide + 1}.png`} alt="illustration" className={styles.tutoIllustration} />

            <h3>{title[slide][0]}<span>{title[slide][1]}</span></h3>

            <div className={styles.content} ref={container} onClick={goToNextSlide}>
              {/* Flèche gauche */}


              <p className={"t3"}>{content[slide]}</p>
            </div>
          </div>

          <div className={styles.radioInputs}>
            <div className={styles.arrowLeft} onClick={goToPrevSlide}>
              <NavigateBeforeRoundedIcon></NavigateBeforeRoundedIcon>
            </div>
            <div className={styles.inputList}>
              <input
                type="radio"
                name="tutorial"
                id="slide0"
                onChange={onChangeHandler}
                checked={slide === 0}
                value={0}
              />
              <input
                type="radio"
                name="tutorial"
                id="slide1"
                onChange={onChangeHandler}
                checked={slide === 1}
                value={1}
              />
              <input
                type="radio"
                name="tutorial"
                id="slide2"
                onChange={onChangeHandler}
                checked={slide === 2}
                value={2}
              />
              <input
                type="radio"
                id="slide3"
                name="tutorial"
                onChange={onChangeHandler}
                checked={slide === 3}
                value={3}
              />
            </div>
            <div className={styles.arrowRight} onClick={goToNextSlide}>
              <NavigateNextRoundedIcon></NavigateNextRoundedIcon>
            </div>

          </div>

        </div>
      </div>
    </>

  );
}
